import React, { useState } from "react";
import AcxInputLabel from "../AcxInputLabel";
import AcxFileButton from "./AcxFileButton";
import AcxRemoveFileButton from "./AcxRemoveFileButton";
import { useTheme } from "@mui/material";

interface AcxFilePickerProps {
    name: string;
    onChange: (files: File[]) => void;
    defaultValue?: File[];
    accept: string;
    shrink?: boolean;
    infoText?: string;
}

function AcxFilePicker(props: AcxFilePickerProps) {
    const theme = useTheme();
    const [files, setFiles] = useState<File[]>(props.defaultValue ?? []);
    const [labelFocus, setLabelFocus] = useState<boolean | undefined>();

    function onFileChange(event: any) {
        // CR: I absolutely could not get this to work any other way than "any"
        const fils = event.target.files || new FileList();
        setFiles(Array.from(fils));
        props.onChange(Array.from(fils));
    }

    const onFileClick = () => {
        fileInputRef.current?.click();
    };
    const onRemoveClick = () => {
        const curFile = fileInputRef.current;
        if (curFile) {
            curFile.value = "";
        }
        setFiles([]);
        props.onChange([]);
    };
    const fileInputRef = React.createRef<HTMLInputElement>();
    return (
        <div>
            <AcxInputLabel
                id={"filepicker-label"}
                focused={labelFocus}
                htmlFor={`file-picker-${props.name}`}
                shrink={props.shrink}
                labelText={`Select ${props.name}`}
                sx={{
                    fontFamily: theme.typography.fontFamily,
                    color: theme.palette.text.primary,
                    fontSize: "12px",
                    lineHeight: "16px",
                }}
                infoText={props.infoText}
            />
            <input
                // accept={props.accept}
                accept="*"
                onChange={onFileChange}
                style={{ display: "none" }}
                id={"file-picker-" + props.name}
                multiple
                type="file"
                ref={fileInputRef}
            />
            <div
                style={{
                    borderRadius: theme.shape.borderRadius,
                    border: "1px solid",
                    borderColor: theme.palette.black.light,
                    backgroundColor: theme.palette.white.main,
                    display: "flex",
                    height: "32px",
                    alignItems: "center",
                }}
            >
                <input
                    onBlur={() => setLabelFocus(false)}
                    onFocus={() => setLabelFocus(true)}
                    type="text"
                    onChange={() => {}}
                    value={files ? files.map((f) => f.name).join(", ") : ""}
                    style={{
                        backgroundColor: "none",
                        border: "none",
                        flex: "1 1 auto",
                        minWidth: "20px",
                        fontSize: "14px",
                        lineHeight: "24px",
                        fontFamily: theme.typography.fontFamily,
                        borderRadius: theme.shape.borderRadius,
                    }}
                />
                <AcxRemoveFileButton
                    onClick={onRemoveClick}
                ></AcxRemoveFileButton>
                <AcxFileButton onClick={onFileClick} />
            </div>
        </div>
    );
}
AcxFilePicker.defaultProps = {
    shrink: false,
};

export default AcxFilePicker;
